import React, { useMemo } from 'react'
import { SUI, Dropdown, IconButton } from 'shared/ui'
import MessengerLinkItem from './MessengerLinkItem'
import TranscriptLinktItem from './TranscriptLinkItem'

import styles from './styles.less'

const MoreButtonDropdown = ({ room }) => {
  const options = useMemo(
    () =>
      [
        {
          key: 'transcript-link',
          value: 'transcript-link',
          as: TranscriptLinktItem,
          matrixRoomId: room.matrixRoomId,
        },
        room?.bridgeType?.startsWith('g.bridge.messenger.') && {
          key: 'messenger-link',
          value: 'messenger-link',
          as: MessengerLinkItem,
          roomId: room.id,
        },
      ].filter(o => !!o),
    [room]
  )

  if (options.length === 0) return null

  return (
    <SUI>
      <div className="more" data-test-id="MoreMenu">
        <Dropdown
          className={styles.dropdown}
          icon={null}
          options={options}
          selectOnBlur={false}
          trigger={
            <IconButton
              name="optionsHorizontal"
              size="medium"
              className="menu-button"
              svg
            />
          }
        />
      </div>
    </SUI>
  )
}

export default MoreButtonDropdown
